import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../../../services/account.service';
import { MatDialog } from '@angular/material/dialog';
import { InvoiceDialogComponent } from './invoice-dialog/invoice-dialog.component';
import { MarkAsPaidComponent } from './mark-as-paid/mark-as-paid.component';
import { PaidDetailsComponent } from './paid-details/paid-details.component';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
// tslint:disable-next-line:max-line-length
import { CancelStatementDialogComponent } from 'src/app/modules/jaldee-subscription/subscription-statements/statements/statement-list/cancel-statement-dialog/cancel-statement-dialog.component';




@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.css']
})
export class InvoicesComponent implements OnInit {
  subscriptionStatus = 'NotPaid';
  accountId: number;
  invoices: any = [];
  configData: any = {};
  invoiceStatus: any;

  constructor(private route: ActivatedRoute, private router: Router, private activatedRoute: ActivatedRoute,private accountService: AccountService, private dialog: MatDialog,
    private commonFilter: CommonfilterService) {
    this.commonFilter.getConfigData()
    .subscribe(res => {
      this.configData = res;
      this.invoiceStatus = this.configData.invoiceStatusDetails;
    });
   }

  ngOnInit() {

    this.route.parent.params.subscribe(params => {
      this.accountId = params['id'];
      this.getInvoices(this.accountId, this.subscriptionStatus);

    });
  }
  statusChanged(event) {
  this.subscriptionStatus = event;
    this.getInvoices(this.accountId, event);

  }
  getInvoices(id, status) {
    this.accountService.getInvoices(id, status)
      .subscribe(res => {

        this.invoices = res;
      });
  }
  getInvoice(uuid) {
    this.router.navigate(['../../../../subscription', 'print'], { queryParams: { invoiceUuid: uuid }, relativeTo: this.activatedRoute });
   
    // const dialogRef = this.dialog.open(InvoiceDialogComponent, { 
    //   width: '700px',
    //   data: uuid
    // });

    // dialogRef.afterClosed().subscribe(result => {

    //   this.getInvoices(this.accountId, this.subscriptionStatus);

    // });
  }
  markAsPaid(invoice) {
    const markasPaidDialog = this.dialog.open(MarkAsPaidComponent, {
      width: '900px',
      data: invoice
    });

    markasPaidDialog.afterClosed().subscribe(result => {

      this.getInvoices(this.accountId, this.subscriptionStatus);

    });

  }
  cancelInvoice(invoiceUuid) {
    const dialogRef = this.dialog.open(CancelStatementDialogComponent, {
      width: '700px',
      data: invoiceUuid
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getInvoices(this.accountId, this.subscriptionStatus);

    });

  }
  showPaymentDetails(invoiceUuid) {
    const paidDialog = this.dialog.open(PaidDetailsComponent, {
      width: '900px',
      data: invoiceUuid

    });
    paidDialog.afterClosed().subscribe(result => {

    });

  }

}
